import { P } from "apparatus/library/common";
import { MoveIndividual } from "../move";
// Contains methods for aligning objects.
export var Align;
(function (Align) {
    /**
     * Aligns objects to a certain direction. Returns commands to be
     * executed to align the objects. Both arrows and apparatus can be moved.
     */
    function align(components, direction) {
        components = components.filter(c => c !== undefined || c !== null);
        if (components.length <= 1)
            return;
        const property = direction;
        const axis = direction == "left" || direction == "right" ? "x" : "y";
        const operator = direction == "left" || direction == "top" ? "min" : "max";
        // Detect left-most edge.
        let extremity = components.reduce((v, c) => Math[operator](v, c.alignmentBounds[property]), components[0].alignmentBounds[property]);
        // Move all items towards this edge.
        return new MoveIndividual(components.map(c => {
            var delta = P(0, 0);
            delta[axis] = extremity - c.alignmentBounds[property];
            return { id: c.id, delta };
        }));
    }
    Align.align = align;
    function alignCenters(components, axis) {
        components = components.filter(c => c !== undefined || c !== null);
        if (components.length <= 1)
            return;
        const center = components.reduce((v, c) => v + c.alignmentBounds.center[axis], 0) / components.length;
        // Move all items towards this edge.
        return new MoveIndividual(components.map(c => {
            var delta = P(0, 0);
            delta[axis] = center - c.alignmentBounds.center[axis];
            return { id: c.id, delta };
        }));
    }
    Align.alignCenters = alignCenters;
})(Align || (Align = {}));
